import { useEffect, useState } from 'react';

/**
 * Convert seconds into minute:second format
 * @param {Number} timeInSeconds
 */
function sec2time(timeInSeconds) {
    const pad = (num, size) => {
        return `000${num}`.slice(size * -1);
    };
    const time = parseFloat(timeInSeconds).toFixed(3);
    const minutes = Math.floor(time / 60) % 60;
    const seconds = Math.floor(time - minutes * 60);
    if (minutes >= 0 && seconds >= 0) {
        return `${pad(minutes, 2)}:${pad(seconds, 2)}`;
    }
    return null;
}

/**
 * Hook for Reverse Otp timer
 * @param {Number} value
 * Uses - `const [seconds, setSeconds] = useOtpTimes(60);`
 */
const useOtpTimes = value => {
    const [seconds, setSeconds] = useState(value);
    useEffect(() => {
        const interval = setInterval(() => {
            setSeconds(seconds - 1);
        }, 1000);
        if (seconds < 0) {
            clearInterval(interval);
        }

        return () => clearInterval(interval);
    }, [seconds]);
    return [sec2time(seconds), setSeconds];
};

export default useOtpTimes;
